define(
    "diy/undo-redo/Ui",
    [
        'jquery',
        'Modernizr',
        'diy/util/helper',
        'diy/undo-redo/constants'
    ],
    /**
     *
     * @param {jQuery|{Function()::jQuery}} $
     * @param {Modernizr} Modernizr
     * @param {diy.util.Helper} helper
     * @param {module.undoRedo.constants} constants
     * @returns {module.undoRedo.Ui.prototype}
     */
    function ($, Modernizr, helper, constants) {
        'use strict';
        var
            Ui;

        /**
         * @class module.undoRedo.Ui
         * @template module.undoRedo.Ui
         * @lends {module.undoRedo.Ui.prototype}
         * @constructor
         */
        Ui = Klazz.extend({
            /** @type {module.undoRedo.FeatureSet} */
            features: null,
            /** @type {module.undoRedo.Api} */
            api: null,
            /** @type {diy.editor.Toolbar} */
            toolbar: null,

            element: null,

            displayLimit: 0,

            flags: {
                isListCollapsed: false,
                isWidgetExpanded: false,
                isTouchEnabled: false,

                blockerId: '',
                uiEnabled: true,

                customScrollBarInitialized: false
            },

            messages: {
                tooltipClickHereToUndo: '',
                tooltipClickHereToRedo: '',
                tooltipCanNotBeUndone: '',
                loadingText: ''
            },

            options: {
                collapseListOnMouseLeave: true,
                mobileMode: false
            },
            entries:{},

            /**
             * constructor; is called from undoRedo api as a member;
             * adds undo-redo user interface to diy toolbar
             *
             * @param {module.undoRedo.Api} api
             * @param {Number} displayLimit
             * @param {Object} messages
             * @param {module.undoRedo.FeatureSet} features
             * @param {diy.editor.Toolbar} toolbar
             */
            initialize: function(api, displayLimit, messages, features, toolbar) {
                this.api = api;
                this.toolbar = toolbar;
                this.displayLimit = displayLimit;
                $.extend(true, this.messages, messages);
                this.features = features;

                this.flags.isTouchEnabled = diy.editor.uiPreference.isPointerModeTouch();


                this.options.mobileMode = (this.flags.isTouchEnabled) ? true : this.options.mobileMode;
                if (this.options.mobileMode === true) {
                    this.options.collapseListOnMouseLeave = false;
                }

                this.element = this.createElement();
            },

            /**
             * envelop buttons to a panel element into diy toolbar
             *
             * @returns {*|HTMLElement}
             */
            createElement: function() {
                var element = $('<div id="undo-redo-history">').wrap('<div class="diye undo-redo-widget">').parent();
                this.toolbar.pushToPanel('center', element);
                return $('#undo-redo-history');
            },


            /**
             * Returns html elements corresponding to an entry in undo list
             *
             * @param {module.undoRedo.UiEntry[]} list
             * @param {Number} index Number representing positioning in list
             * @param {String} listType String - 'undo' | 'redo'
             * @param {Boolean=} firstRow
             * @param {Number=} numberOfItemsInList Number - how may items should be displayed in list
             * @returns {string}
             */
            getEntryHtml: function(list, index, listType, firstRow, numberOfItemsInList) {
                var entry = list[index],
                    hasData = (typeof entry !== 'undefined'),
                    actionTextMessage = (firstRow && hasData)? this.convertToTooltip(entry.getMessage()) : '',
                    executeIconTooltip = (
                        hasData ?
                            (entry.isExecutable() ?
                            ' title="' +
                            this.messages['tooltipClickHereTo' + this.capitalize(listType)] +
                            actionTextMessage + '"' :
                            ' title="' + this.messages.tooltipCanNotBeUndone + actionTextMessage + '"'
                            ) : ''
                    ),
                    isExecutableClass = (
                        hasData ?
                            (entry.isExecutable() ? '' : ' notExecutable') :
                            ' disabled'
                    ),
                    dataEntryId = (
                        hasData ?
                        ' data-key="' + entry.getKey() + '" ' :
                            ''
                    ),
                    dataTracking = (
                        hasData ?
                            (' data-tracking="' + this.capitalize(listType) + (firstRow ? '' : index + 1) + '" ') :
                            ''
                    ),
                    dataLabel = (
                        hasData ?
                            entry.getLabel() :
                            ''
                    ),
                    collapseIconHtml = (
                        firstRow === true ?
                        '<div class="collapseIcon ' + ((list.length) ? '' : 'disabled ') + '"' + '>' +
                        '<div class="icon"><span class="index">' + numberOfItemsInList + '</span></div>' +
                        '</div>' :
                            ''
                    ),
                    entryDetailHtml = (
                    '<div class="entryDetail" ' + dataEntryId + '>' +
                    '<div class="entryMessage">' + dataLabel + '</div>' +
                    '</div>'
                    ),
                    executeIconHtml = (
                    '<div class="executeIcon" ' + executeIconTooltip + dataEntryId + dataTracking + '>' +
                    '<div class="icon"></div>' +
                    '</div>'
                    )
                    ;
                return [
                    '<div class="listEntry', (firstRow === true ? ' lastEntry' : '') , isExecutableClass , '"',
                    dataEntryId, dataTracking, '" >', entryDetailHtml, collapseIconHtml, executeIconHtml, '</div>'
                ].join("");
            },

            /**
             * Returns html elements corresponding to a undo | redo list
             *
             * @param list Array
             * @param type String 'undo'|'redo'
             * @returns {string}
             */
            getListHtml: function(list, type) {
                var i = 0, html, displayLimit;

                displayLimit = (this.displayLimit !== 0)?
                    Math.min(list.length, this.displayLimit) :
                    list.length;

                html = ['<div class="', type,  '-list undo-redo-list list-collapsed ', (!list.length? 'emptyList' : ''), '">'];
                html.push(this.getEntryHtml(list, 0, type, true, displayLimit));

                if (list.length) {
                    html.push('<div class="allEntries toolbarCalloutPanel">');
                    html.push('<div class="scrollInner">');
                    html.push('<div class="pointer"></div>');
                    for (i = 0; i < displayLimit; i++) {
                        html.push(this.getEntryHtml(list, i, type));
                    }
                    html.push('</div>'); //class="scrollInner"
                    html.push('</div>');
                }

                html.push('</div>');
                return html.join("");
            },


            storeIncomingData: function storeIncomingData(data) {
                this.entries = {};
                data.undoList.forEach(
                    /** @param {module.undoRedo.UiEntry} entry */ function (entry){
                        this.entries[entry.getKey()] = entry;
                    }.bind(this)
                );
                data.redoList.forEach(
                    /** @param {module.undoRedo.UiEntry} entry */ function (entry){
                        this.entries[entry.getKey()] = entry;
                    }.bind(this)
                );
            },
            /**
             * Repaints the ui based on given data; unblock ui elements;
             *
             * @param data {Object=}
             */
            refresh: function(data) {
                if (data === undefined) {
                    data = {
                        undoList: [],
                        redoList: [],
                        lastEntry: null
                    };
                }
                this.storeIncomingData(data);

                var content = [
                    this.getListHtml(data.undoList, 'undo'),
                    this.getListHtml(data.redoList, 'redo'),
                    '<div class="spacer lists-spacer"><div class="icon"></div></div>'
                ].join("");

                //at this point we're removing some markup that might have
                // a custom scrollbar instance attached, if so, destroy  the instance
                if (this.flags.customScrollBarInitialized === true) {
                    this.element.find('.scrollHandle').diy_scrollHandle('destroy');
                    this.flags.customScrollBarInitialized = false;
                }

                this.element.html(content);
                this.flags.isWidgetExpanded = true;

                if (data.undoList.length !== 0 ||  data.redoList.length !== 0) {
                    this.initListEvents();
                    this.flags.isWidgetExpanded = false;
                }

                this.unblockUi();
            },

            initListEvents: function() {
                var container = this.element.find('.undo-redo-list:not(.emptyList)'),
                    executeFilter = '.listEntry:not(.notExecutable):not(.lastEntry)',
                    expandFilter = '.listExpandIcon, .collapseIcon',
                    self = this;

                if (this.options.mobileMode === true) {
                    expandFilter += ' , .lastEntry:not(.notExecutable) .executeIcon';
                } else {
                    executeFilter += ' , .lastEntry:not(.notExecutable) .executeIcon';
                }

                //execute functionality
                this.addExecuteEvent(container, executeFilter);
                container.each(function() {
                    self.addExpandEvent(
                        $(this).find('.allEntries'),
                        $(this).find(expandFilter),
                        'vertical'
                    );
                });

                this.addSelectedEntryEvent(container, false);

                //at this point we have the freshly rendered lists => create the virtual scrolls
                this.setupCustomScrollBar();
            },

            /**
             * sets up custom scrollbar on the lists
             * @access private
             */
            setupCustomScrollBar: function () {
                //do not init the scrollbar twice
                if (this.flags.customScrollBarInitialized === false) {
                    var $undoRedoLists = this.element.find('.scrollInner');
                    $undoRedoLists.diy_scrollHandle({arrows: true});
                    this.flags.customScrollBarInitialized = true;
                }
            },

            addExecuteEvent: function(container, selector, excludeSelector) {
                var
                    elements = container.find(selector),
                    self = this;

                container.find(selector).unbind('click.undo-redo');

                if (excludeSelector) {
                    elements = elements.not(excludeSelector);
                }

                elements.bind('click.undo-redo', function() {
                    self.tracking($(this).attr('data-tracking'));
                    self.onExecute($(this).attr('data-key'));
                });
            },

            /**
             * Method used for tracking
             *
             * @param tracking
             */
            tracking: function(tracking) {
                if (this.flags.uiEnabled === false) {
                    return;
                }
                $(document).trigger('diy-editor-undo-redo-link-tracking', {
                    actionName: tracking
                });
            },

            expandList: function(list, direction) {
                var
                    self = this,
                    collapseOther = this.element.find('.allEntries.list-expanded');

                if (collapseOther.length) {
                    this.collapseList(collapseOther, 'vertical');
                }

                list.removeClass('list-collapsed').addClass('list-expanded');
                list.parent().removeClass('list-collapsed').addClass('list-expanded');

                if (direction === 'vertical') {
                    list.slideDown('fast', function() {
                        self.flags.isListCollapsed = false;
                        //now we can safely draw the scrollbar
                        list.find('.scrollInner').trigger('contentchanged');
                    }.bind(this));
                } else {
                    list.show();
                    //now we can safely draw the scrollbar
                    list.find('.scrollInner').trigger('contentchanged');
                    self.flags.isListCollapsed = false;
                }
                if (list.hasClass('redo-list')) {
                    self.tracking('OpenRedoList');
                } else {
                    self.tracking('OpenUndoList');
                }
            },

            collapseList: function(list, direction) {
                var self = this;

                if (direction === 'vertical') {
                    list.slideUp('fast', function() {
                        self.flags.isListCollapsed = true;
                    });
                } else {
                    list.hide();
                    self.flags.isListCollapsed = true;
                }
                list.removeClass('list-expanded').addClass('list-collapsed');
                list.parent().removeClass('list-expanded').addClass('list-collapsed');
            },

            collapseAll: function(){
                var self = this;
                this.element.find('.allEntries.list-expanded').each(function() {
                    self.collapseList($(this));
                });
            },

            addExpandEvent: function(listContainer, expandElements, direction) {
                var self = this;

                listContainer.hide().addClass('list-collapsed');

                expandElements.unbind('click.undo-redo').bind('click.undo-redo', function(event) {
                    if (self.flags.uiEnabled === false) {
                        return;
                    }
                    if (listContainer.hasClass('list-collapsed')) {
                        self.expandList(listContainer, direction);
                    } else {
                        self.collapseList(listContainer, direction);
                    }
                    event.stopImmediatePropagation();
                    return false;
                });

                if (this.options.collapseListOnMouseLeave) {

                    if (this.options.collapseListOnMouseLeave) {
                        //implement inline the hover intent functionality
                        //because direct usage of hoverIntent fails due to
                        //incompatibilities between this component design and
                        //hover intent design
                        var timerId = null;
                        this.element.bind('mouseleave', function(){
                            if (timerId === null) {
                                timerId = setTimeout(function(){
                                    self.collapseList(listContainer, 'vertical');
                                    timerId = null;
                                }, 500);
                            }
                        });
                        this.element.bind('mouseenter', function(){
                            if (timerId !== null) {
                                clearTimeout(timerId);
                                timerId = null;
                            }
                        });
                    }
                    else {
                        // collapse when mouse leaves the list
                        this.element.mouseleave(function() {
                            self.collapseList(listContainer, 'vertical');
                        });
                    }
                }
            },

            addSelectedEntryEvent: function(container, reverse) {
                var entrySelector = '.listEntry',
                    eventSelector = '.allEntries .listEntry, .lastEntry .executeIcon, .lastEntry .collapseIcon',
                    selectedClass = 'selectedEntry',
                    self = this,

                    markSelectedEntries = function() {
                        var $entry = ($(this).hasClass('collapseIcon') || $(this).hasClass('executeIcon'))?
                                $(this).parent() :
                                $(this)
                            ;

                        if ($(this).hasClass('executeIcon')) {
                            $entry.addClass('showMessage');
                        }
                        if ($(this).hasClass('collapseIcon')) {
                            $entry.removeClass('showMessage');
                        }
                        $entry.parent().find(entrySelector).removeClass(selectedClass);
                        if (reverse === true) {
                            $entry.nextAll(entrySelector).andSelf().addClass(selectedClass);
                        } else {
                            $entry.prevAll(entrySelector).andSelf().addClass(selectedClass);
                        }

                        $entry.parent().find(entrySelector).each(function() {
                            self.onDeselect(this);
                        });

                        if (reverse === true) {
                            $entry.nextAll(entrySelector).andSelf().each(
                                function(index, element) { self.onSelect(element); }
                            );
                        } else {
                            $entry.prevAll(entrySelector).andSelf().each(
                                function(index, element) { self.onSelect(element); }
                            );
                        }
                    },

                    unmarkSelectedEntries = function() {

                        $(this).find(entrySelector).removeClass(selectedClass + ' showMessage');
                        $(this).find(entrySelector).each(
                            function(index, element) { self.onDeselect(element); }
                        );
                    };

                if (self.flags.isTouchEnabled) {
                    container.find(eventSelector).bind('click.undo-redo', markSelectedEntries);
                } else {
                    container.find(eventSelector).unbind('mouseenter').bind('mouseenter', markSelectedEntries);
                    container.unbind('mouseleave').mouseleave(unmarkSelectedEntries);
                }
            },
            /**
             *
             * @param {String} key
             * @returns {module.undoRedo.UiEntry|null}
             */
            getItemByKey: function getItemByKey(key) {
                var entry = this.entries[key];
                return (typeof entry !== 'undefined')? entry : null;
            },
            onSelect: function(element) {
                if (this.options.mobileMode === true) {
                    return;
                }
                var entry = this.getItemByKey($(element).attr('data-key'));
                if (entry && typeof entry.onSelect === 'function'){
                    entry.onSelect();
                }
            },

            onDeselect: function(element) {
                if (this.options.mobileMode === true) {
                    return;
                }
                var entry = this.getItemByKey($(element).attr('data-key'));
                if (entry && typeof entry.onDeselect === 'function'){
                    entry.onDeselect();
                }
            },

            /**
             * Called by user to trigger entry execution
             *
             * @param key
             */
            onExecute: function(key) {
                if (this.flags.uiEnabled === false) {
                    return;
                }

                var entry = this.getItemByKey(key);

                this.collapseAll();

                if (entry !== null) {
                    try {
                        this.block();
                        entry.onClick()
                            .done(
                                function /*onFulfilled*/(){
                                    this.unblock();
                                }.bind(this),
                                function /*onRejected*/(){
                                    this.unblock();
                                    this.showErrorBox();
                                }.bind(this)
                            );
                    } catch (error) {
                        this.unblock();
                        this.showErrorBox();
                    }

                }
            },

            /**
             * Disable click on interface elements keeping hover; will look the same
             * but the user will not be able to execute entries
             *
             * used when an action is "in execution" state or an entry is about to be created on server side
             *
             */
            blockUi: function() {
                this.collapseAll();
                this.flags.uiEnabled = false;
            },

            /**
             * Reverse method for blockUi
             * @see blockUi
             */
            unblockUi: function() {
                this.flags.uiEnabled = true;
            },

            /**
             * Block ui elements
             * Adds a blocker over the whole diy
             * Used when an entry is executed
             */
            block: function() {
                this.blockUi();
                this.flags.blockerId = helper.overlay({loadingText: this.messages.loadingText});
            },

            /**
             * Reverse method for block
             * @see block
             */
            unblock: function() {
                this.unblockUi();
                $('#' + this.flags.blockerId).remove();
            },


            capitalize: function(string) {
                return string.charAt(0).toUpperCase() + string.slice(1);
            },

            /**
             * Converts the html markup for the undo entry label to a raw text which
             * we can place in a tooltip.
             *
             * HACK: because the markup for the undo/redo labels is stored in the
             * database, we have to extract the text label "by force". This should
             * be refactored so the markup is built entirely in the client and we
             * only store the raw data in the db.
             */
            convertToTooltip: function(message) {
                var tooltipLabel = '',
                    messageHtml,
                    spanText,
                    spanEl;

                if (message) {
                    tooltipLabel += ' - ';

                    // wrap the markup with a 'p' tag, otherwise the inner span will
                    // be considered as the root element when we wrap with $
                    messageHtml = $('<p></p>').html(message);

                    //extract the span text, which is present for a text/heading module
                    spanEl = messageHtml.find('span');
                    if (spanEl.length) {
                        spanText = spanEl.text();
                        //remove the span so we can take the remainder of the label
                        messageHtml.find('span').remove();
                        tooltipLabel += (spanText.length ? '&quot;' + spanText + '&quot; ' : '');
                    }

                    tooltipLabel += messageHtml.text();
                }

                return tooltipLabel.replace(/"/g, '&quot;');
            },
            /**
             * Displays an error message to the user, requesting for page refresh
             *  overlay is blocking all interface, the error is unknown and we can't let the user do any changes
             *  until the new data is loaded from server (the undo engine may be out of sync - or newer data is a new tab
             *  or something failed in applying snapshot client / server side)
             */
            showErrorBox: function (error) {
                var errorHtml, errorBox, errorButton;
                error = error || this.messages.errors.generic;

                errorHtml = [
                    '<div><div class="undo-redo-dialog-box-wrapper with-icon">',
                    '<div class="dialog-box-icon ui-icon ui-icon-alert"></div>',
                    '<div class="dialog-box-title"></div>',
                    '<div class="dialog-box-description"></div>',
                    '</div></div>'
                ].join("");

                errorBox = $(errorHtml);

                errorBox.find('.dialog-box-title').html(error.title);
                errorBox.find('.dialog-box-description').html(error.description);

                if (error.button) {
                    errorButton = {
                        text: error.button,
                        click: function () {
                            errorBox.remove();
                            helper.browserReload(null, null, 100);
                        }.bind(this)
                    };
                }

                errorBox.diy_confirmationDialog({
                    zIndex: 100210,
                    width: 386,
                    overlayCls: null, /* use default semi-transparent overlay */
                    position: {
                        my: 'center middle',
                        at: 'center middle'
                    },
                    buttons: errorButton ? [errorButton] : []
                });
            }
        });

        return Ui;
    }
);



/*****************
 ** WEBPACK FOOTER
 ** ./source/cdn/document_root/s/diy/undo-redo/Ui.js
 ** module id = 910
 ** module chunks = 0
 **/